import React from "react";
import AppModal from "../common/AppModal";
import SendFeeReminderForm from "../../forms/SendFeeReminderForm";

interface FeeReminderModalProps {
  open: boolean;
  onClose: () => void;
  classroomId: string;
  classroomName?: string;
  loading: boolean;
  error: string | null;
}

const FeeReminderModal: React.FC<FeeReminderModalProps> = ({
  open,
  onClose,
  classroomId,
  classroomName,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Dispatch Fee Reminders"
    width="sm"
    loading={loading}
  >
    <SendFeeReminderForm
      classroomId={classroomId}
      classroomName={classroomName}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default FeeReminderModal;
